import { render, staticRenderFns } from "./Films.vue?vue&type=template&id=a78782d4"
import script from "./Films.vue?vue&type=script&lang=js"
export * from "./Films.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports